import { Box, keyframes } from '@mui/material'

const drawRoute = keyframes`
  0% { stroke-dashoffset: 164; }
  69% { stroke-dashoffset: 0; }
  100% { stroke-dashoffset: 0; }
`

const bounceIn = keyframes`
  0%   { opacity: 0; transform: scale(0); }
  46%  { opacity: 0; transform: scale(0); }
  54%  { opacity: 1; transform: scale(1.25); }
  62%  { opacity: 1; transform: scale(0.95); }
  68%  { opacity: 1; transform: scale(1.05); }
  78%  { opacity: 1; transform: scale(1); }
  100% { opacity: 1; transform: scale(1); }
`

type Props = {
  size?: number
}

export function RouteAnimation({ size = 48 }: Props) {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      sx={{
        '& .route-trace': { animation: `${drawRoute} 3.2s ease-in-out infinite` },
        '& .lower-pin': {
          transformOrigin: '50.666px 42px',
          opacity: 0,
          transform: 'scale(0)',
          animation: `${bounceIn} 3.2s ease-in-out infinite`,
        },
      }}
    >
      <defs>
        <clipPath id="route-anim-clip">
          <rect width="64" height="64" fill="white" />
        </clipPath>
        <mask id="route-anim-mask" maskUnits="userSpaceOnUse" x="0" y="0" width="64" height="64">
          <rect width="64" height="64" fill="black" />
          <path
            className="route-trace"
            d="M 13.33 34.67 L 26.67 34.67 C 30.5 34.67 34.67 36.5 34.67 40 C 34.67 43.5 30.5 45.33 26.67 45.33 L 13.33 45.33 C 9 45.33 5.33 47 5.33 50.67 C 5.33 54 9 56 13.33 56 L 50.67 56"
            stroke="white"
            strokeWidth="14"
            strokeLinecap="round"
            fill="none"
            strokeDasharray="150"
            strokeDashoffset="164"
          />
        </mask>
      </defs>
      <g clipPath="url(#route-anim-clip)">
        <g>
          <path
            d="M18.6667 5.33398C15.8377 5.33398 13.1246 6.45779 11.1242 8.45818C9.12381 10.4586 8 13.1717 8 16.0007C8 22.5607 16.24 28.2673 17.2 28.8807C17.6354 29.1674 18.1453 29.3202 18.6667 29.3202C19.188 29.3202 19.6979 29.1674 20.1333 28.8807C21.0933 28.2673 29.3333 22.5607 29.3333 16.0007C29.3333 13.1717 28.2095 10.4586 26.2091 8.45818C24.2088 6.45779 21.4956 5.33398 18.6667 5.33398Z"
            fill="#4383CC"
          />
          <path
            d="M16.6239 20.9379C17.2706 21.2025 17.9631 21.3366 18.6617 21.3326C20.0671 21.313 21.4133 20.7622 22.4305 19.7904C22.928 19.2961 23.3229 18.7079 23.5924 18.0599C23.8619 17.4119 24.0007 16.7168 24.0007 16.0148C24.0007 15.3128 23.8619 14.6177 23.5924 13.9697C23.3229 13.3216 22.928 12.7335 22.4305 12.2391C21.688 11.4891 20.7395 10.9777 19.7057 10.7699C18.672 10.5621 17.5999 10.6675 16.6261 11.0725C15.6524 11.4776 14.8211 12.164 14.2382 13.0442C13.6554 13.9244 13.3474 14.9585 13.3535 16.0148C13.3275 16.3688 13.3275 16.7243 13.3535 17.0783C13.4449 17.4174 13.5882 17.7403 13.7782 18.0355C13.8842 18.3622 14.0458 18.6681 14.2559 18.9396C14.4393 19.2438 14.6527 19.5288 14.8929 19.7904C15.3889 20.2833 15.9771 20.6732 16.6239 20.9379Z"
            fill="#D4E3F3"
          />
        </g>
        <g mask="url(#route-anim-mask)">
          <path
            d="M53.334 58.6667H13.334C11.2123 58.6667 9.17742 57.8238 7.67713 56.3235C6.17684 54.8232 5.33398 52.7884 5.33398 50.6667C5.33398 48.5449 6.17684 46.5101 7.67713 45.0098C9.17742 43.5095 11.2123 42.6667 13.334 42.6667H26.6673C27.3746 42.6667 28.0528 42.3857 28.5529 41.8856C29.053 41.3855 29.334 40.7072 29.334 40C29.334 39.2928 29.053 38.6145 28.5529 38.1144C28.0528 37.6143 27.3746 37.3333 26.6673 37.3333H16.0007C15.2934 37.3333 14.6151 37.0524 14.115 36.5523C13.6149 36.0522 13.334 35.3739 13.334 34.6667C13.334 33.9594 13.6149 33.2811 14.115 32.781C14.6151 32.281 15.2934 32 16.0007 32H26.6673C28.7891 32 30.8239 32.8429 32.3242 34.3431C33.8245 35.8434 34.6673 37.8783 34.6673 40C34.6673 42.1217 33.8245 44.1566 32.3242 45.6569C30.8239 47.1571 28.7891 48 26.6673 48H13.334C12.6267 48 11.9485 48.2809 11.4484 48.781C10.9483 49.2811 10.6673 49.9594 10.6673 50.6667C10.6673 51.3739 10.9483 52.0522 11.4484 52.5523C11.9485 53.0524 12.6267 53.3333 13.334 53.3333H53.334C54.0412 53.3333 54.7195 53.6143 55.2196 54.1144C55.7197 54.6145 56.0007 55.2928 56.0007 56C56.0007 56.7072 55.7197 57.3855 55.2196 57.8856C54.7195 58.3857 54.0412 58.6667 53.334 58.6667Z"
            fill="#A1C1E6"
          />
        </g>
        <g className="lower-pin">
          <path
            d="M50.6667 50.6667C49.9594 50.6667 49.2811 50.3857 48.781 49.8856C48.2809 49.3855 48 48.7072 48 48V42.6667C48 41.9594 48.2809 41.2811 48.781 40.781C49.2811 40.281 49.9594 40 50.6667 40C51.3739 40 52.0522 40.281 52.5523 40.781C53.0524 41.2811 53.3333 41.9594 53.3333 42.6667V48C53.3333 48.7072 53.0524 49.3855 52.5523 49.8856C52.0522 50.3857 51.3739 50.6667 50.6667 50.6667Z"
            fill="#0E4686"
          />
          <path
            d="M50.666 42.666C55.0843 42.666 58.666 39.0843 58.666 34.666C58.666 30.2477 55.0843 26.666 50.666 26.666C46.2477 26.666 42.666 30.2477 42.666 34.666C42.666 39.0843 46.2477 42.666 50.666 42.666Z"
            fill="#0E4686"
          />
        </g>
      </g>
    </Box>
  )
}
